import { render, staticRenderFns } from "./giftcard-send-image.vue?vue&type=template&id=4e2bee30"
import script from "./giftcard-send-image.vue?vue&type=script&lang=js"
export * from "./giftcard-send-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports